import React, { useState, useEffect } from 'react';
import { 
  AccessTimeFilled, 
  CheckCircle, 
  KeyboardArrowDownOutlined, 
  KeyboardArrowUpOutlined,
  Search
} from '@mui/icons-material';
import './Engineer.css';
import { toast } from 'react-toastify';

export default function DayOrders() {

    const token = localStorage.getItem("token");
  
    const [expandedOrderId, setExpandedOrderId] = useState(null);
    const [orders, setOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTripId, setActiveTripId] = useState(null);

    const formatDate = (dateString) => {
        if (!dateString) return "تاريخ غير محدد";
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: 'numeric', month: 'long', year: 'numeric'
        });
    };

    const formatTime = (dateString) => {
        if (!dateString) return "--:--";
        return new Date(dateString).toLocaleTimeString('ar-EG', {
            hour: '2-digit', minute: '2-digit', hour12: true
        }).replace("AM", "صباحاً").replace("PM", "مساءاً");
    };

    const fetchOrders = async () => {
    try {
      const response = await fetch(
        "https://estbn.com/EstbnNew/public/api/stuff/driver/orders",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );
      const result = await response.json();
    const ordersList = Array.isArray(result?.data?.orders)
      ? result.data.orders
      : Object.values(result?.data?.orders || {});

    setOrders(ordersList);

    const currentOrder = ordersList.find((o) => o.flags?.is_current);
    if (currentOrder) setExpandedOrderId(currentOrder.id);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
    };

    console.log(orders);
    console.log("isArray:", Array.isArray(orders));
    
    const filteredOrders = Array.isArray(orders)
    ? orders.filter(
        (order) =>
          order.order_number
            ?.toLowerCase()
            .includes((searchTerm || "").toLowerCase()) ||
          order.service_snapshot?.name
            ?.toLowerCase()
            ?.includes((searchTerm || "").toLowerCase()) ||
          order.address
            ?.toLowerCase()
            ?.includes((searchTerm || "").toLowerCase()),
      )
    : [];

    const hasActiveTrip = filteredOrders.some(
    (order) => order.status === "Dispatched",
    );

    const handleStartTrip = async (orderId) => {
      try {
        const formData = new FormData();
        formData.append("order_id", orderId);
        const response = await fetch(
          "https://estbn.com/EstbnNew/public/api/stuff/trips/start",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          },
          );
          console.log(response.data);
        const data = await response.json();
        if (response.ok) {
            const tripId = data?.data?.trip?.id;
            console.log("Returned Trip ID:", tripId);
            setActiveTripId(tripId);
            fetchOrders();
            console.log("Trip Started:", data);
            toast.success('Trip Started Successfully' , {autoClose:3000})
        } else {
            toast.error(data.message , {autoClose:3000})
            console.log("Start Trip Error:", data);
        }
      } catch (error) {
            console.error("Start Trip Failed:", error);
      }
    };
    
    const handleEndTrip = async (tripId) => {
 if (!tripId) {
    console.log("Trip ID is null");
    return;
       }

       try {
       const response = await fetch(
         `https://estbn.com/EstbnNew/public/api/stuff/trips/end/${tripId}`,
         {
           method: "POST",
           headers: {
             Authorization: `Bearer ${token}`,
           },
         },
       );

       const data = await response.json();

       if (response.ok) {
         console.log("Trip Ended:", data);
         setActiveTripId(null);
         fetchOrders();
         toast.success("Trip Ended Successfully", { autoClose: 3000 });
       } else {
         console.log("End Trip Error:", data);
       }
     } catch (error) {
       console.error("End Trip Failed:", error);
     }
    };
    
    const getButtonConfig = (order) => {
   const { status, flags } = order;

   if (status !== "Dispatched" && status !== "Assigned") {
     return {
       text: "تم إنهاء الرحلة بنجاح",
       style: { backgroundColor: "#0777da80", color: "white" },
       className: "",
       disabled: true,
       onClick: null,
     };
   }

   if (status === "Dispatched") {
     return {
       text: "إنهاء الرحلة",
       className: "btn-dark",
       style: {},
       disabled: false,
         onClick: () => handleEndTrip(activeTripId),
     };
   }

   if (status === "Assigned") {
     return {
       text: "ابدأ الرحلة",
       className: "btn-dark",
       style: {},
       disabled: !flags?.is_current || hasActiveTrip,
       onClick: () => handleStartTrip(order.id),
     };
   }

   return {
     text: "غير متاح",
     className: "btn-secondary",
     style: {},
     disabled: true,
     onClick: null,
   };
    };

    useEffect(() => { 
    fetchOrders();
    }, []);
    
    return (
        <div className="w-100 py-4 px-3 px-md-4" dir="rtl">
            {/* orders harder */}
            <div className="text-end mb-4">
                <h5 className="fw-bold mb-3" style={{fontSize: '1.1rem'}}>راجع الخدمات المنفذة من قبل الفني قبل تأكيد الطلب</h5>
                <div className="position-relative" style={{maxWidth: '400px', marginRight: '0'}}>
                    <input 
                        type="text" 
                        className="form-control pe-5 rounded-3 border-light-subtle shadow-sm" 
                        placeholder="ابحث برقم الطلب أو اسم الخدمة.." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Search className="position-absolute top-50 translate-middle-y text-muted" style={{right: '15px'}} />
                </div>
            </div>
             {/* orders list */}
            <div className="row g-3">
                <div className="col-12">
                    {filteredOrders.map((order) =>
                    {
                      const buttonConfig = getButtonConfig(order);
                       return (
                         <div
                           key={order.id}
                           className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden bg-white"
                         >
                           {/* num & date */}
                           <div
                             className="d-flex justify-content-between align-items-center p-3 bg-light cursor-pointer"
                             onClick={() =>
                               setExpandedOrderId(
                                 expandedOrderId === order.id ? null : order.id,
                               )
                             }
                           >
                             <div className="d-flex align-items-center gap-3">
                               <span className="text-muted small d-none d-sm-inline">
                                 طلب رقم
                               </span>
                               <span className="fw-bold fs-6">
                                 #{order.order_number?.slice(-6) || order.id}
                               </span>
                               <div
                                 className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                 style={{
                                   width: "32px",
                                   height: "32px",
                                   backgroundColor:
                                     order.status === "Completed"
                                       ? "#1565AB"
                                       : "#7E1BAD",
                                   color: "white",
                                 }}
                               >
                                 {order.status === "Completed" ? (
                                   <CheckCircle style={{ fontSize: 18 }} />
                                 ) : (
                                   <AccessTimeFilled style={{ fontSize: 18 }} />
                                 )}
                               </div>
                             </div>
                             <div className="d-flex align-items-center gap-2">
                               <span className="fw-bold">
                                 {formatDate(
                                   order?.route_info?.actual_arrival_time ||
                                     order?.route_info?.estimated_arrival_time,
                                 )}
                               </span>
                               {expandedOrderId === order.id ? (
                                 <KeyboardArrowUpOutlined />
                               ) : (
                                 <KeyboardArrowDownOutlined />
                               )}
                             </div>
                           </div>
                           {/* expand details */}
                           {expandedOrderId === order.id && (
                             <div className="p-3 p-md-4 bg-white">
                               <div className="p-3 border rounded-4">
                                 <div className="mb-3 text-end pb-2 border-bottom">
                                   <span className="text-muted small">
                                     الخدمة المطلوبة:{" "}
                                   </span>
                                   <span className="fw-bold text-dark">
                                     {order.service_snapshot?.name ||
                                       "خدمة صيانة"}
                                   </span>
                                 </div>

                                 <div className="row g-3">
                                   <div className="col-4 text-end">
                                     <p className="text-muted small mb-1">
                                       حالة الطلب
                                     </p>
                                     <p
                                       className="fw-bold mb-0"
                                       style={{
                                         fontSize: "0.85rem",
                                         color: "black",
                                       }}
                                     >
                                       {order.status}
                                     </p>
                                   </div>

                                   <div className="col-4 text-end border-end border-start">
                                     <p className="text-muted small mb-1">
                                       الوقت
                                     </p>
                                     <p
                                       className="fw-bold mb-0"
                                       style={{ fontSize: "0.85rem" }}
                                     >
                                       {formatTime(
                                         order.route_info
                                           ?.estimated_arrival_time,
                                       )}
                                     </p>
                                   </div>

                                   <div className="col-4">
                                     <p className="text-muted small mb-1">
                                       العنوان
                                     </p>
                                     <p
                                       className="fw-bold mb-0 text-muted"
                                       style={{
                                         fontSize: "0.8rem",
                                         lineHeight: "1.4",
                                       }}
                                     >
                                       {order.address || "غير متوفر"}
                                     </p>
                                   </div>
                                 </div>

                                 <div className="mt-4 pt-2 d-flex justify-content-center">
                                   <button
                                     className={`btn py-2 px-5 rounded-3 fw-bold w-25 ${buttonConfig.className}`}
                                     style={buttonConfig.style}
                                     disabled={buttonConfig.disabled}
                                     onClick={buttonConfig.onClick}
                                   >
                                     {buttonConfig.text}
                                   </button>
                                 </div>
                               </div>
                             </div>
                           )}
                         </div>
                       );
                         }
                    )}
                    {filteredOrders.length === 0 && (
                        <div className="text-center py-5 text-muted">لا توجد طلبات مطابقة للبحث</div>
                    )}
                </div>
            </div>
        </div>
    );
}